import {Directive, Input, ElementRef, OnInit} from '@angular/core';
import {LazyLoaderService} from '../../../core/services/lazy-loader/lazy-loader.service';

@Directive({
    selector: '[appElevationGraph]'
})
export class ElevationGraphDirective implements OnInit {

  // shows a clickable legend for the graph
  @Input() showLegend: boolean;

  // show the climate zones as visual tiers within the graphed area
  @Input() showClimateZones: boolean;

  // show the points (which are tooltip-able) along the route
  @Input() showPoints: boolean;

  // show the area under the lines
  @Input() showArea: boolean;

  // show the X-axis label
  @Input() showXAxisLabel: boolean;

  // what is the low value on the y-axis
  @Input() yAxisLow: number;

  // height (in pixels) of the graph
  @Input() height: number;

  // the series (graph data)
  @Input() series: object;

  onLoadElevationGraph() {
    this.lazyLoader.load('app-elevation-graph').then(componentEl => {
      componentEl['showLegend'] = this.showLegend;
      componentEl['showClimateZones'] = this.showClimateZones;
      componentEl['showPoints'] = this.showPoints;
      componentEl['showArea'] = this.showArea;
      componentEl['showXAxisLabel'] = this.showXAxisLabel;
      componentEl['yAxisLow'] = this.yAxisLow;
      componentEl['height'] = this.height;
      componentEl['series'] = this.series;
      this.elementRef.nativeElement.appendChild(componentEl);
    });
  }

  constructor(
    private elementRef: ElementRef,
    private lazyLoader: LazyLoaderService) {}

  ngOnInit() {
    this.onLoadElevationGraph();
  }
}
